import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
interface MainLayoutProps {
  children: React.ReactNode;
  title?: string;
  onLogout: () => void;
}
export function MainLayout({
  children,
  title = 'Dashboard',
  onLogout
}: MainLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);
  return <div className="min-h-screen bg-slate-50 flex font-sans" data-id="element-249">
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} data-id="element-250" />

      {/* Backdrop overlay for mobile */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity duration-300" onClick={closeSidebar} aria-hidden="true" data-id="element-251" />}

      <div className="flex-1 ml-0 lg:ml-64 flex flex-col min-w-0 transition-all duration-300" data-id="element-252">
        <Header title={title} onMenuClick={toggleSidebar} onLogout={onLogout} data-id="element-253" />
        <main className="flex-1 p-6 overflow-y-auto" data-id="element-254">
          <div className="max-w-7xl mx-auto space-y-6" data-id="element-255">{children}</div>
        </main>
      </div>
    </div>;
}